export class IncentiveConfig {
    id: string = null;
    incentiveRuleName: string = "";
    incentiveCategory: string = "ON_SIGNUP";
    rechargeType: string = "UNIT";
    refractionCreditUnit: number = null;
    refractionUsageInDays: number = null;
    // amountCreditUnit: number = null;
    refractionUsageInUnit: number = null;
    refractionUseIncludesFreeCredits: boolean = true;
    // freeRefractionsToBeUsed: number = null;
    // amountCreditToReferrer: number = null;
    minRefractionRechargeUnit: number = null;
    maxRefractionRechargeUnit: number = null;
    minRefractionRechargeCredit: number = null;
    maxRefractionRechargeCredit: number = null;
    // cashback: number = null;
    // transactionAmountType: string = "FLAT";
    // maxCashbackAmount: number = null;
    // maxTransactionUnit: number = null;
    // isApplicableOnlyForReferrals: boolean = false;
    onlyForReferredUser: boolean = false;
    payoutToUser: number = null;
    payoutToReferredUser: number = null;
    payoutType: string = "FLAT";
    maxPayoutAmount: number = null;
    addtionalBenefits: string = null;
    numberOfTimes: number = null;
    validityInDays: number = null;
    status: boolean = true;
    termsAndConditions: any[] = null;
    isConditionOnly: boolean = false;
}